// Passo "Mover card" da régua (mode: 'move'). Mesmas regras do servidor
// (Funnels::FollowUpStepValidator / Funnels::FollowUpMove): destino vazio é o
// próprio funil; coluna Ganho/Perdido não é destino porque recusa card aberto.

// Mesmos padrões do Funnel::TERMINAL_PATTERNS, aplicados ao nome visível.
const TERMINAL_PATTERNS = ['ganh', 'won', 'perd', 'lost'];

export const isMoveStep = step => step?.mode === 'move';

const stageLabel = (key, stage) => stage?.label || stage?.name || key;

export const isTerminalStage = (key, stage) => {
  const visible = stageLabel(key, stage).toLowerCase();
  return TERMINAL_PATTERNS.some(pattern => visible.includes(pattern));
};

export const sortedStages = stages =>
  Object.entries(stages || {})
    .map(([key, stage]) => ({
      key,
      label: stageLabel(key, stage),
      position: stage?.position ?? 0,
      terminal: isTerminalStage(key, stage),
    }))
    .sort((a, b) => a.position - b.position);

export const moveTargetFunnel = (step, funnels, currentFunnelId) => {
  const id = step?.move_funnel_id ?? currentFunnelId;
  return (funnels || []).find(funnel => funnel.id === id) || null;
};

// Etapas oferecidas como destino: sem as de fechamento e, no próprio funil,
// sem a etapa dona do passo (mover para onde já está não faz nada).
export const moveStageOptions = (funnel, { ownFunnel, stageKey }) =>
  sortedStages(funnel?.stages).filter(
    stage => !stage.terminal && !(ownFunnel && stage.key === stageKey)
  );

export const moveTargetLabels = (step, funnels, currentFunnelId) => {
  const funnel = moveTargetFunnel(step, funnels, currentFunnelId);
  const stage = sortedStages(funnel?.stages).find(
    candidate => candidate.key === step?.move_stage_name
  );
  if (!funnel || !stage) return null;
  return { funnel: funnel.name, stage: stage.label };
};
